import React from 'react';
import { useSticky } from './useSticky';
import './scss/sticky-component.scss';

const StickyComponent = ({ children }) => {
  const { isSticky, element } = useSticky();

  return (
    <div ref={element} className={`sticky-content ${isSticky ? 'is-sticky' : ''}`}>
      {children}
    </div>
  );
};

export default StickyComponent;